import HospitalChapter from "@/components/HospitalChapter";
import ClosingCTA from "@/components/ClosingCTA";

export default function HospitalCanteen() {
  return (
    <main data-testid="hospital-canteen-page" className="pt-16">
      <HospitalChapter />
      <ClosingCTA />
    </main>
  );
}
